import { Box, Button, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';

import { SearchBadge } from '../../Header/HeaderRight/SearchBarModal/SearchBarModalBody/SearchBadge';
import { InnerLink } from '../../InnerLink';
import { BADGES } from '../../KnowledgeAgentSearchHero';
import { SearchInput } from '../SearchInput';

import css from './index.module.scss';

type NoResultsFoundV2Props = {
  onSearch: (newTerm: string) => void;
  initialSearchTerm?: string;
};

const NoResultsFoundV2 = ({ onSearch, initialSearchTerm }: NoResultsFoundV2Props) => {
  const { t } = useTranslation();

  return (
    <Box className={css.wrapper}>
      <Box className={css.card} direction="vertical" gap={4}>
        <Box direction="vertical" gap="SP2" className={css.cardContentTop}>
          <SearchInput
            initialSearchTerm={initialSearchTerm}
            onSearch={onSearch}
            retryGenerateAnswer={() => onSearch(initialSearchTerm || '')}
            hideGradient />
          <Box className={css.badges}>
            {BADGES.map((badge) => (
              <SearchBadge
                key={badge.key}
                badge={badge}
                onClick={() =>
                  onSearch(t(badge.key))
                }
              />
            ))}
          </Box>
        </Box>
        <Box className={css.cardContentBottom} direction="vertical" gap={4}>
          <Box direction="vertical" gap={1} align="center">
            <Text className={css.noResultsTitle}>
              {t('search-results-page.no-results-found.v2.new-title', { term: initialSearchTerm })}
            </Text>
            <Text>{t('search-results-page.no-results-found.v2.subtitle')}</Text>
          </Box>
          <Box>
            <InnerLink href={'/'}>
              <Button skin="inverted">
                {t('search-results-page.no-results-found.return-to-homepage')}
              </Button>
            </InnerLink>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NoResultsFoundV2;
